<template>
  <a-spin :spinning="spinning">
    <section>
      <div class="modal-header">
        <div class="modal-title">
          <a-icon type="unordered-list" /> 加入人员列表
        </div>
      </div>
      <react-table
        ref="rt"
        :table-data="tableData"
        :total-items="totalItems"
        :actions-type="actionsType"
        :columns="columns"
        :current-page="pageNumber"
        :hide-row-selection="false"
        :hide-pagination="false"
        @emitSelectChange="selectChange"
        @emitOnPageChange="updatePageChange"
        @emitShowSizeChange="updateShowSizeChange"
      >
        <a-row :gutter="8" class="btn--container">
          <a-col class="gutter-row" :span="8">
            <a-input
              v-model="searchDto.filterText"
              :placeholder="l('请输入姓名...')"
            />
          </a-col>
          <a-col class="gutter-row" :span="8">
            <a-button type="primary" @click="searchData">
              {{ l("Search") }}
            </a-button>
            <a-button @click="refreshGoFirstPage"> {{ l("Reset") }}</a-button>
          </a-col>
        </a-row>
      </react-table>
    </section>
  </a-spin>
</template>

<script>
import { AppComponentBase, ModalComponentBase } from "@/shared/component-base";
import { CommonServiceProxy } from "@/shared/common-service";
import { AppConsts } from "@/abpPro/AppConsts";
import { environment } from "@/environments/environment";
import ReactTable from "@/components/react-table";
import { ModalHelper } from "@/shared/helpers";
import moment from "moment";

export default {
  name: "signperson-list",
  mixins: [AppComponentBase, ModalComponentBase],
  components: { ReactTable },
  data() {
    return {
      filterText: "",
      sharePersonnelId: "",
      projectId: "",
      taskId: "",
      statisticalMonth: "",
      spinning: false,
      // 表单
      formLayout: "horizontal",
      isDisabled: false,

      tableKey: "",
      commonService: null,
      personnelService: null,

      tableData: [],
      // 总数
      totalItems: 0,
      // 当前页码
      pageNumber: 1,
      // 共多少页
      totalPages: 1,
      // 条数显示范围
      pagerange: [1, 1],
      // 显示条数
      pageSizeOptions: ["10", "20", "30", "40"],
      actionsType: {},
      signStatuList: ["未签署", "单方签署", "已经签署", "归档", "已通知"],
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 16,
        },
      },
      // 用户表格
      columns: [
        {
          title: "姓名",
          dataIndex: "joinPersonnelName",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "joinPersonnelName" },
        },
        {
          title: "手机号",
          dataIndex: "phone",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "phone" },
        },
        {
          title: "身份证",
          dataIndex: "idCard",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "idCard" },
        },
        {
          title: "项目名称",
          dataIndex: "projectName",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "projectName" },
        },
        {
          title: "任务名称",
          dataIndex: "taskName",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "taskName" },
        },
        {
         title: "加入时间",
          dataIndex: "joinTime",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "joinTime" },
        },
      ],
      selectedRowKeys: [],
      selectedRows: [],
      searchDto: {
        agreementTemplateId: "",
        projectId: null,
        signStatus: "",
        filterText: "",
        sorting: "",
        MaxResultCount: 30,
        SkipCount: 0,
      },
      projectData: [
        {
          value: null,
          text: "请选择",
        },
      ],
    };
  },
  created() {
    this.commonService = new CommonServiceProxy(this.$apiUrl, this.$api);
    this.fullData(); // 模态框必须,填充数据到data字段
    this.uploadUrl = AppConsts.uploadBaseUrl + "/API/Upload";
    this.subdirName = environment.production ? "abpProd" : "abpDev";
  },
  mounted() {
    if (this.params) {
      this.$nextTick(() => {});
    }
    this.getData();
  },
  methods: {
    getData() {
      this._getPersonPagedByRealNameList();
    },
    searchData() {
      this.searchDto.SkipCount = 0;
      this._getPersonPagedByRealNameList();
    },
    async _getPersonPagedByRealNameList() {
      this.$refs.rt.clearData();
      this.spinning = true;
      try {
        const params = {
          projectId: this.projectId,
          taskId: this.taskId,
          sharePersonnelId: this.sharePersonnelId,
          statisticalMonth: this.statisticalMonth,
          filterText: this.searchDto.filterText,
          sorting: this.searchDto.sorting,
          maxResultCount: this.searchDto.MaxResultCount,
          skipCount: this.searchDto.SkipCount,
        };
        // console.log(params);
        let res = await this.commonService.post({
          url:
            "/api/services/app/ProjectUser/GetShareJoinUserList",
          params,
        });
        this.tableData = res.items.map((item) => {
          return {
            ...item,
          };
        });
        this.totalItems = res.totalCount;
        this.totalPages = Math.ceil(2 / this.searchDto.MaxResultCount);
        this.pagerange = [
          (this.pageNumber - 1) * this.searchDto.MaxResultCount + 1,
          this.pageNumber * this.searchDto.MaxResultCount,
        ];
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    async _getProjectPersonnelAgreement() {
      this.spinning = true;
      try {
        let res = await this.commonService.get({
          url: "/api/services/app/ProjectPersonnelAgreement/GetList",
          params: {
            personnelId: this.personnelAgreementItem.userId,
            projectId: this.personnelAgreementItem.projectId,
            contractNo: this.filterText,
          },
        });
        this.tableData = res.map((item) => {
          return {
            ...item,
            signTimeStr: item.signTime
              ? moment(item.signTime).format("YYYY-MM-DD HH:mm:ss")
              : "-",
            creationTimeStr: item.creationTime
              ? moment(item.creationTime).format("YYYY-MM-DD HH:mm:ss")
              : "-",
            signStatusStr: this.signStatuList[item.signStatus],
          };
        });
        this.totalItems;
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    async _agreementTemplateGetSelectData() {
      this.spinning = true;
      try {
        let res = await this.commonService.get({
          url: "/api/services/app/ProjectPersonnelAgreement/GetSelectData",
          params: {
            projectId: this.personnelAgreementItem.projectId,
          },
        });
        this.spinning = false;
        this.seclectModalParams.selectList = res;
      } catch (error) {
        this.spinning = false;
      }
    },
    initActionsType() {
      let _this = this;
      let obj = {
        type: "templete-list",
        isShow: true,
        fns: {
          dropList: [],
        },
      };
      if (this.signstatus == 1) {
        obj.fns.dropList = [
          {
            granted: true,
            name: this.l("预览协议"),
            icon: "eye",
            fn: (data) => {
              console.log(data);
              if (data.viewUrl) {
                window.open(data.viewUrl);
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
          {
            granted: true,
            name: this.l("下载协议"),
            icon: "download",
            fn: (data) => {
              if (data.downloadUrl) {
                window.location.href = data.downloadUrl;
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
        ];
      } else {
        obj.fns.dropList = [
          {
            granted: true,
            name: this.l("通知签署"),
            icon: "notification",
            fn: (data) => {
              console.log(data);
              if (data.isNoty) {
                _this.$message.info("已通知过!");
                return;
              }
              let personnelIds = [];
              personnelIds.push(data.personId);
              _this.notificationPersonnelAgreement(data.id, personnelIds);
            },
          },
          {
            granted: true,
            name: this.l("撤回"),
            icon: "delete",
            fn: (data) => {
              console.log(data);
              let personnelIds = [];
              personnelIds.push(data.personId);
              _this.delPersonnelAgreement(data.id, personnelIds);
            },
          },
        ];
      }
      this.actionsType = obj;
    },
    /**
     * 重置
     */
    refreshGoFirstPage() {
      this.pageNumber = 1;
      this.searchDto.SkipCount = 0;
      this.searchDto.filterText = "";
      this.getData();
    },
    delPersonnelAgreement(projectAgreementId, personnelIds) {
      let _that = this;
      this.message.confirm("是否确定撤回", (res) => {
        if (res) {
          _that.delData(projectAgreementId, personnelIds);
        }
      });
    },
    showTotalFun() {
      return this.l(
        "GridFooterDisplayText",
        this.pageNumber,
        this.totalPages,
        this.totalItems,
        this.pagerange[0],
        this.pagerange[1]
      );
    },
    batchDelData() {
      const selectCount = this.selectedRowKeys.length;
      if (selectCount <= 0) {
        abp.message.warn(this.l("PleaseSelectAXPlaceHolder", "撤回"));
        return;
      }
      console.log(this.selectedRowKeys);
      console.log(this.selectedRows);
      let personnelIds = this.selectedRows.map((item) => {
        return item.personId;
      });
      let projectAgreementId = this.selectedRows.map((item) => {
        return item.id;
      });
      let projectAgreementIdArr = projectAgreementId.filter(function (
        item,
        index,
        projectAgreementId
      ) {
        return projectAgreementId.indexOf(item, 0) === index;
      });
      let _that = this;
      _that.message.confirm(
        `是否对${personnelIds.length}个人进行撤回`,
        "撤回",
        (res) => {
          if (res) {
            _that.delData(projectAgreementIdArr[0], personnelIds);
          }
        }
      );
    },
    async delData(projectAgreementId, personnelIds) {
      this.spinning = true;
      try {
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonAgreementTemplate/Revocation",
          params: {
            projectAgreementId: projectAgreementId,
            personnelIds: personnelIds,
          },
        });
        this.refreshGoFirstPage();
        this.$notification["success"]({
          message: res,
        });
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    batchDownload() {
      const selectCount = this.selectedRowKeys.length;
      if (selectCount <= 0) {
        abp.message.warn(this.l("PleaseSelectAXPlaceHolder", "下载"));
        return;
      }
    },
    notification() {
      console.log(this.selectedRowKeys);
      const selectCount = this.selectedRowKeys.length;
      if (selectCount <= 0) {
        abp.message.warn(this.l("PleaseSelectAXPlaceHolder", "通知签署"));
        return;
      }
      console.log(this.selectedRowKeys);
      console.log(this.selectedRows);
      let personnelIds = this.selectedRows.map((item) => {
        return item.personId;
      });
      let projectAgreementId = this.selectedRows.map((item) => {
        return item.id;
      });
      let projectAgreementIdArr = projectAgreementId.filter(function (
        item,
        index,
        projectAgreementId
      ) {
        return projectAgreementId.indexOf(item, 0) === index;
      });
      let _that = this;
      _that.message.confirm(
        `是否对${personnelIds.length}个人进行通知签署`,
        "系统提示",
        (res) => {
          if (res) {
            _that.notificationData(projectAgreementIdArr[0], personnelIds);
          }
        }
      );
    },
    notificationPersonnelAgreement(projectAgreementId, personnelIds) {
      let _that = this;
      this.message.confirm("是否确定通知签署", (res) => {
        if (res) {
          _that.notificationData(projectAgreementId, personnelIds);
        }
      });
    },
    async notificationData(projectAgreementId, personnelIds) {
      this.spinning = true;

      try {
        let res = await this.commonService.post({
          url:
            "/api/services/app/UnnaturalPersonAgreementTemplate/SendSignNotice",
          params: {
            projectAgreementId: projectAgreementId,
            personnelIds: personnelIds,
          },
        });
        this.refreshGoFirstPage();
        console.log(res);
        this.$notification["success"]({
          message: res,
        });
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    selectChange(data) {
      let { selectedRowKeys, selectedRows } = data;
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    handleChange(value) {
      this.searchDto.projectId = value;
      // console.log(value);
    },
    updatePageChange(newV) {
      let { page, pageSize } = newV;
      this.onChange(page, pageSize);
    },
    onChange(page, pageSize) {
      this.pageNumber = page;
      this.searchDto.SkipCount = (page - 1) * this.searchDto.MaxResultCount;
      this.getData();
    },
    updateShowSizeChange(newV) {
      let { current, size } = newV;
      this.showSizeChange(current, size);
    },
    showSizeChange(current, size) {
      this.pageNumber = 1;
      this.searchDto.MaxResultCount = size;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
// @import "../../../../styles/common.less";

.modal-header {
  .anticon-share-alt {
    margin-right: 10px;
  }
}
.form-wrapper {
  .ant-form-item {
    margin-bottom: 14px;
  }
}
</style>
